module.exports = __webpack_public_path__ + "media/images/fb_index_image3-ccf276d714a5e85a34de1cfaf00a9ddb.png";